import imageCompression from 'browser-image-compression';

const MAX_SIZE_MB = 10;
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

// Compresses the image to ≤9.5 MB. Throws 'compression_failed' if the target cannot be achieved.
// onProgress(0–100) is called throughout the process.
export const compressImageIfNeeded = async (file, { onProgress } = {}) => {
  const options = {
    maxSizeMB: 9.5,
    maxWidthOrHeight: 3840,
    useWebWorker: false,
    initialQuality: 0.9,
    maxIteration: 20,
    fileType: 'image/jpeg',
    onProgress: (p) => onProgress?.(p),
  };

  const compressed = await imageCompression(file, options);

  if (compressed.size > MAX_SIZE_BYTES) {
    throw new Error('compression_failed');
  }

  return compressed;
};
